import styled from "styled-components/native"

export const Wrapper = styled.View`
    height: 100%;
    background: #CDCDCD;
`